
import { prop, Vue } from "vue-class-component";

export type ManagingCountryOption = {
  id: number;
  code: string;
  name: string;
  value?: string;
};

class Props {
  options = prop<ManagingCountryOption[]>({
    default: () => [],
    required: false,
    type: Array,
  });
  modelValue = prop<ManagingCountryOption | null>({
    default: null,
    required: false,
  });
  isLoading = prop<boolean>({
    default: false,
    required: false,
    type: Boolean,
  });
  isDisabled = prop<boolean>({
    default: false,
    required: false,
    type: Boolean,
  });
}

export default class ManagingCountryField extends Vue.with(Props) {
  get selectedName() {
    return this.modelValue?.name
      ? { name: this.modelValue?.name, value: this.modelValue?.value }
      : { name: "", value: "" };
  }

  get selectedValue() {
    return this.modelValue;
  }

  set selectedValue(val: ManagingCountryOption | null) {
    this.$emit("update:modelValue", val);
  }
}
